import React from "react";
import { Field, ErrorMessage } from "formik";
import { TextError } from "../TextError";
const CheckBox = (props) => {
  const { label, name, options, ...rest } = props;
  return (
    <>
      <label htmlFor={name}>{label}</label>
      <Field as="" id={name} name={name} {...rest} className="form-control">
        {({ field }) => {
          return options.map((curr, index) => {
            return (
              <React.Fragment>
                <input
                  type="checkbox"
                  id={curr.value}
                  {...field}
                  value={curr.value}
                  checked={field.value.includes(curr.value)}
                />
                <label htmlFor={curr.key}>{curr.key} </label>
              </React.Fragment>
            );
          });
        }}
      </Field>
      <ErrorMessage name={name} component={TextError} />
    </>
  );
};

export default CheckBox;
